var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "knowledge-base"
  }, [_c('aside', {
    staticClass: "knowledge-sidebar"
  }, [_c('div', {
    staticClass: "sidebar-header"
  }, [_vm._m(0), _c('p', [_vm._v(_vm._s(_vm.filteredArticles.length) + " výsledkov")])]), _c('label', {
    staticClass: "search-field"
  }, [_c('span', [_vm._v("Hľadať")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.search,
      expression: "search",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "placeholder": "napr. refinancovanie, príjem, SLSP"
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.search = $event.target.value.trim();
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm.activeFilterChips.length ? _c('div', {
    staticClass: "active-filters"
  }, [_vm._l(_vm.activeFilterChips, function (chip) {
    return _c('button', {
      key: chip.type,
      staticClass: "filter-chip",
      attrs: {
        "type": "button",
        "title": "Zru\u0161i\u0165 filter: ".concat(chip.label)
      },
      on: {
        "click": function click($event) {
          return _vm.removeFilter(chip.type);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(chip.label))]), _c('strong', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])]);
  }), _c('button', {
    staticClass: "clear-filters",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v(" Zobraziť všetko ")])], 2) : _vm._e(), _vm.loadError ? _c('p', {
    staticClass: "fallback-note"
  }, [_vm._v(" Zobrazujem lokálnu kópiu metodiky. Ukladanie bude dostupné po nasadení API. ")]) : _vm._e(), _vm.isAdmin ? _c('div', {
    staticClass: "filter-group"
  }, [_c('div', {
    staticClass: "filter-label"
  }, [_vm._v("Stav")]), _vm._l(_vm.statuses, function (status) {
    return _c('button', {
      key: status.value,
      "class": {
        active: _vm.selectedStatus === status.value
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.selectedStatus = status.value;
        }
      }
    }, [_vm._v(" " + _vm._s(status.label) + " ")]);
  })], 2) : _vm._e(), _c('div', {
    staticClass: "filter-group"
  }, [_c('div', {
    staticClass: "filter-label"
  }, [_vm._v("Témy")]), _vm._l(_vm.topics, function (topic) {
    return _c('button', {
      key: topic,
      "class": {
        active: _vm.selectedTopic === topic
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.selectedTopic = topic;
        }
      }
    }, [_vm._v(" " + _vm._s(topic) + " ")]);
  })], 2), _c('div', {
    staticClass: "filter-group"
  }, [_c('div', {
    staticClass: "filter-label"
  }, [_vm._v("Banky")]), _vm._l(_vm.banks, function (bank) {
    return _c('button', {
      key: bank,
      "class": {
        active: _vm.selectedBank === bank
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.selectedBank = bank;
        }
      }
    }, [_vm._v(" " + _vm._s(bank) + " ")]);
  })], 2)]), _c('main', {
    staticClass: "knowledge-results"
  }, [_vm._l(_vm.filteredArticles, function (article) {
    return _c('div', {
      key: article.id,
      staticClass: "article-row",
      "class": {
        active: _vm.selectedArticle && _vm.selectedArticle.id === article.id
      }
    }, [_c('button', {
      staticClass: "article-row-main",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.selectArticle(article);
        }
      }
    }, [_c('span', {
      staticClass: "row-title"
    }, [_vm._v(_vm._s(article.title))]), _c('span', {
      staticClass: "row-summary"
    }, [_vm._v(_vm._s(_vm.previewText(article)))]), _c('span', {
      staticClass: "row-tags"
    }, [_vm.isAdmin && article.statusKey === 'draft' ? _c('span', {
      staticClass: "tag draft"
    }, [_vm._v("rozpracované")]) : _vm._e(), _vm._l(article.topics.slice(0, 2), function (topic) {
      return _c('span', {
        key: "".concat(article.id, "-").concat(topic),
        staticClass: "tag"
      }, [_vm._v(" " + _vm._s(topic) + " ")]);
    }), _vm._l(article.banks.slice(0, 2), function (bank) {
      return _c('span', {
        key: "".concat(article.id, "-").concat(bank),
        staticClass: "tag bank"
      }, [_vm._v(" " + _vm._s(bank) + " ")]);
    })], 2)]), _vm.isAdmin ? _c('button', {
      staticClass: "icon-button row-edit-button",
      attrs: {
        "type": "button",
        "title": "Upraviť článok",
        "aria-label": "Upraviť článok"
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.openEditor(article);
        }
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "aria-hidden": "true"
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 20h4.2L18.8 9.4l-4.2-4.2L4 15.8V20zM16 3.8l4.2 4.2 1.1-1.1a1.5 1.5 0 0 0 0-2.1l-2.1-2.1a1.5 1.5 0 0 0-2.1 0L16 3.8z"
      }
    })])]) : _vm._e()]);
  }), !_vm.loading && _vm.filteredArticles.length === 0 ? _c('div', {
    staticClass: "empty-state"
  }, [_c('h3', [_vm._v("Nič som nenašiel")]), _c('p', [_vm._v("Skúste kratší výraz alebo vypnite niektorý filter.")])]) : _vm._e()], 2), _vm.selectedArticle && !_vm.editing ? _c('article', {
    staticClass: "knowledge-detail"
  }, [_c('div', {
    staticClass: "detail-top"
  }, [_c('div', [_c('p', {
    staticClass: "eyebrow"
  }, [_vm._v(_vm._s(_vm.statusLabel(_vm.selectedArticle)))]), _c('h1', [_vm._v(_vm._s(_vm.selectedArticle.title))])]), _c('div', {
    staticClass: "detail-actions"
  }, [_vm.selectedArticle.sourceUrl ? _c('a', {
    attrs: {
      "href": _vm.selectedArticle.sourceUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Zdroj")]) : _vm._e(), _vm.isAdmin ? _c('button', {
    staticClass: "icon-button",
    attrs: {
      "type": "button",
      "title": "Upraviť článok",
      "aria-label": "Upraviť článok"
    },
    on: {
      "click": function click($event) {
        return _vm.openEditor(_vm.selectedArticle);
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 20h4.2L18.8 9.4l-4.2-4.2L4 15.8V20zM16 3.8l4.2 4.2 1.1-1.1a1.5 1.5 0 0 0 0-2.1l-2.1-2.1a1.5 1.5 0 0 0-2.1 0L16 3.8z"
    }
  })])]) : _vm._e()])]), _c('div', {
    staticClass: "detail-tags"
  }, [_vm.isAdmin && _vm.selectedArticle.statusKey === 'draft' ? _c('span', {
    staticClass: "tag draft"
  }, [_vm._v("rozpracované")]) : _vm._e(), _vm._l(_vm.selectedArticle.topics, function (topic) {
    return _c('span', {
      key: topic,
      staticClass: "tag"
    }, [_vm._v(_vm._s(topic))]);
  }), _vm._l(_vm.selectedArticle.banks, function (bank) {
    return _c('span', {
      key: bank,
      staticClass: "tag bank"
    }, [_vm._v(_vm._s(bank))]);
  })], 2), _c('div', {
    staticClass: "article-body"
  }, [_vm._l(_vm.articleBlocks, function (block, index) {
    return [block.type === 'table' ? _c('div', {
      key: "table-".concat(index),
      staticClass: "article-table-wrap"
    }, [_c('table', {
      staticClass: "article-table"
    }, [_c('thead', [_c('tr', _vm._l(block.headers, function (header) {
      return _c('th', {
        key: "".concat(index, "-").concat(header)
      }, [_vm._v(_vm._s(header))]);
    }), 0)]), _c('tbody', _vm._l(block.rows, function (row, rowIndex) {
      return _c('tr', {
        key: "".concat(index, "-").concat(rowIndex)
      }, _vm._l(row, function (cell, cellIndex) {
        return _c('td', {
          key: "".concat(index, "-").concat(rowIndex, "-").concat(cellIndex)
        }, [_vm._l(_vm.inlineParts(cell), function (part, partIndex) {
          return [part.url ? _c('a', {
            key: "table-link-".concat(index, "-").concat(rowIndex, "-").concat(cellIndex, "-").concat(partIndex),
            attrs: {
              "href": part.url,
              "target": "_blank",
              "rel": "noopener noreferrer"
            }
          }, [_vm._v(" " + _vm._s(part.text) + " ")]) : _c('span', {
            key: "table-text-".concat(index, "-").concat(rowIndex, "-").concat(cellIndex, "-").concat(partIndex)
          }, [_vm._v(_vm._s(part.text))])];
        })], 2);
      }), 0);
    }), 0)])]) : block.type === 'list' ? _c('ul', {
      key: "list-".concat(index),
      staticClass: "article-list"
    }, _vm._l(block.items, function (item, itemIndex) {
      return _c('li', {
        key: "".concat(index, "-").concat(itemIndex)
      }, [_vm._l(item.parts, function (part, partIndex) {
        return [part.url ? _c('a', {
          key: "list-link-".concat(index, "-").concat(itemIndex, "-").concat(partIndex),
          attrs: {
            "href": part.url,
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_vm._v(" " + _vm._s(part.text) + " ")]) : _c('span', {
          key: "list-text-".concat(index, "-").concat(itemIndex, "-").concat(partIndex)
        }, [_vm._v(_vm._s(part.text))])];
      })], 2);
    }), 0) : _c(block.tag, {
      key: "text-".concat(index),
      tag: "component",
      "class": block.className
    }, [_vm._l(block.parts, function (part, partIndex) {
      return [part.url ? _c('a', {
        key: "link-".concat(index, "-").concat(partIndex),
        attrs: {
          "href": part.url,
          "target": "_blank",
          "rel": "noopener noreferrer"
        }
      }, [_vm._v(" " + _vm._s(part.text) + " ")]) : _c('span', {
        key: "text-".concat(index, "-").concat(partIndex)
      }, [_vm._v(_vm._s(part.text))])];
    })], 2)];
  })], 2)]) : _vm._e(), _vm.selectedArticle && _vm.editing ? _c('form', {
    staticClass: "knowledge-detail editor-panel",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveArticle.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "detail-top"
  }, [_vm._m(1), _c('div', {
    staticClass: "detail-actions"
  }, [_c('button', {
    staticClass: "secondary-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeEditor
    }
  }, [_vm._v("Zrušiť")]), _c('button', {
    staticClass: "primary-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.saving
    }
  }, [_vm._v(" " + _vm._s(_vm.saving ? "Ukladám..." : "Uložiť") + " ")])])]), _c('label', {
    staticClass: "editor-field"
  }, [_c('span', [_vm._v("Názov")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.editForm.title,
      expression: "editForm.title",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.editForm.title
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.editForm, "title", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('label', {
    staticClass: "editor-field"
  }, [_c('span', [_vm._v("Krátke zhrnutie")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.editForm.summary,
      expression: "editForm.summary",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": _vm.editForm.summary
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.editForm, "summary", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "editor-row"
  }, [_c('label', {
    staticClass: "editor-field"
  }, [_c('span', [_vm._v("Stav")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.editForm.status,
      expression: "editForm.status"
    }],
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.editForm, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "published"
    }
  }, [_vm._v("Publikované")]), _c('option', {
    attrs: {
      "value": "draft"
    }
  }, [_vm._v("Rozpracované")])])]), _c('label', {
    staticClass: "editor-field"
  }, [_c('span', [_vm._v("Zdrojová URL")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.editForm.sourceUrl,
      expression: "editForm.sourceUrl",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "url"
    },
    domProps: {
      "value": _vm.editForm.sourceUrl
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.editForm, "sourceUrl", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])]), _c('div', {
    staticClass: "editor-row"
  }, [_c('label', {
    staticClass: "editor-field"
  }, [_c('span', [_vm._v("Témy")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.editForm.topics,
      expression: "editForm.topics",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Príjem, Refinancovanie"
    },
    domProps: {
      "value": _vm.editForm.topics
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.editForm, "topics", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('label', {
    staticClass: "editor-field"
  }, [_c('span', [_vm._v("Banky")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.editForm.banks,
      expression: "editForm.banks",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "SLSP, VÚB"
    },
    domProps: {
      "value": _vm.editForm.banks
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.editForm, "banks", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])]), _c('label', {
    staticClass: "editor-field editor-body"
  }, [_c('span', [_vm._v("Obsah")]), _c('div', {
    staticClass: "editor-toolbar",
    attrs: {
      "aria-label": "Formátovanie obsahu"
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.insertHeading(2);
      }
    }
  }, [_vm._v("H2")]), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.insertHeading(3);
      }
    }
  }, [_vm._v("H3")]), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.insertList
    }
  }, [_vm._v("Odrážky")]), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.insertBankTable
    }
  }, [_vm._v("Tabuľka bánk")])]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.editForm.body,
      expression: "editForm.body"
    }],
    ref: "bodyTextarea",
    attrs: {
      "rows": "18",
      "required": ""
    },
    domProps: {
      "value": _vm.editForm.body
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.editForm, "body", $event.target.value);
      }
    }
  })])]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "eyebrow"
  }, [_vm._v("Metodika")]), _c('h2', [_vm._v("Príručka hypotekára")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "eyebrow"
  }, [_vm._v("Editor")]), _c('h1', [_vm._v("Upraviť príspevok")])]);

}]

export { render, staticRenderFns }